import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { GameCardModule } from '@fantaz/tournaments/ui/game-card';
import { EventNumber } from '@fantaz/tournaments/ui/play-event-card';
import { InfoIcon } from 'libs/shared/ui/src/lib/info-icon';
import { ScoreSummaryComponent } from './score-summary/score-summary.component';
@NgModule({
  imports: [
    CommonModule,
    CurrencyModule,
    MaterialModule,
    GameCardModule,
    EventNumber,
    InfoIcon,
  ],
  declarations: [ScoreSummaryComponent],
  exports: [ScoreSummaryComponent],
})
export class TournamentsUiScoreSummaryModule {}
